function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
export const getSchemaORG = (fundTitle, metaDescription, fund) => {
  const withReviews = fund.socialStats.reviews.total > 0 && fund.score !== null;
  const reviewsSchema = withReviews ? {
    '@context': 'http://schema.org',
    '@type': 'Product',
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: fund.score,
      reviewCount: fund.socialStats.reviews.total
    },
    reviewRating: {
      '@type': 'Rating',
      ratingValue: fund.score,
      worstRating: 1,
      bestRating: 5,
      reviewAspect: 'Product'
    }
  } : {};
  const schema = _objectSpread({
    description: `${metaDescription}`,
    name: `${fundTitle}`,
    image: 'https://static.finect.com/img/logo/finect-logo-600x60.png'
  }, reviewsSchema);
  return JSON.stringify(schema);
};